/* RN positioning parity for Tamagui on web.
 *
 * React Native lays every View and Text out as `position: relative`, and
 * react-native-web copies that into its own base style. Tamagui v2's `.is_View`
 * reset does not, so on web ONLY: `top`/`left`/`bottom`/`right` offsets are
 * silently dropped, absolute children anchor to some distant ancestor instead of
 * their parent, `overflow: hidden` fails to clip them, and a positioned element
 * paints over an unpositioned sibling whatever the JSX order says.
 *
 * View and Text together, deliberately — relative on one and static on the other
 * is its own paint-order trap, since CSS draws every positioned element above
 * every unpositioned one.
 *
 * `:where()` carries zero specificity, so this is a DEFAULT, not an override:
 * anything that sets `position` itself still wins regardless of which stylesheet
 * loads first. That matters because Tamagui injects its atomic `_pos-*` classes
 * at runtime, i.e. after this file.
 */
:where(.is_View, .is_Text) {
  position: relative;
}
